import script from "./SampleMaterialFormDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SampleMaterialFormDialog.vue?vue&type=script&setup=true&lang=js"

import "./SampleMaterialFormDialog.vue?vue&type=style&index=0&id=53dc370f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53dc370f"]])

export default __exports__